// extracted by mini-css-extract-plugin
export default {"dataItem":"DataItem_dataItem__eXHOj","title":"DataItem_title__+qSPt","value":"DataItem_value__dSeAz"};